import { render, staticRenderFns } from "./TemporaryCashAllocation.vue?vue&type=template&id=380ed71d&"
import script from "./TemporaryCashAllocation.vue?vue&type=script&lang=js&"
export * from "./TemporaryCashAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports